module.exports = __webpack_public_path__ + "media/images/file_encrypt-2d70513ddafce6dafed1a81f839689e8.png";